export default "__VITE_ASSET__BHJI59YE__"